/* eslint-disable @typescript-eslint/no-explicit-any */
export const mapAgence = (list: {nom: string; id?: any}[]) => {
  return list.map((e: any) => {
    return {
      id: e.id,
      value: e.nom,
      label: e.nom,
    };
  });
};
